<template>
  <div class="col-lg-8" v-if="this.getUsuarioInfo">
    <div class="row">
      <div class="col-12">
        <div class="dash-pro-item mb-30 dashboard-widget">
          <div class="header">
            <h4 class="title" v-if="getUsuarioInfo.tipoPessoa == 'PJ'">Informações da Empresa</h4>
            <h4 class="title" v-else>Informações Pessoais</h4>
            <!-- <span class="edit"><i class="flaticon-edit"></i> Editar</span> -->
          </div>
          <form class="login-form" @submit.prevent="cadastro" v-if="getUsuarioInfo">
            <div class="row">
              <div class="pl-3 mb-1" v-if="getUsuarioInfo.tipoPessoa == 'PJ'">Razão Social</div>
              <div class="pl-3 mb-1" v-else>Nome Completo</div>
              <div class="form-group col-md-12">
                <label for="nome-completo"><i class="fas fa-user"></i></label>
                <input type="text" id="nome-completo" placeholder="Nome completo" v-model="nomeCompleto" required />
              </div>
            </div>

            <div class="row">
              <div class="pl-3 mb-1">Apelido</div>
              <div class="form-group col-12">
                <label for="apelido"><i class="fas fa-user-tag"></i></label>
                <input
                  v-bind:class="verifyNomeUsuario"
                  type="text"
                  id="apelido"
                  placeholder="Apelido"
                  size="15"
                  minlength="5"
                  maxlength="15"
                  v-model="nomeUsuario"
                  @input="debounceCheckNomeUsuario"
                  required
                />
              </div>

              <div class="d-flex w-100 pl-3">
                <p v-if="getLoadingNomeUsuario">
                  <i class="fas fa-spinner fa-spin mr-1"></i>
                  Verificando...
                </p>
                <p v-if="nomeUsuario !== nomeUsuarioCheck && getNomeUsuarioExists && !nomeUsuarioError && !getLoadingNomeUsuario" class="text-danger">
                  <i class="fas fa-times-circle text-danger mr-1"></i>
                  Esse nome de usuário já existe, por favor escolha outro!
                </p>
                <p v-if="nomeUsuario !== nomeUsuarioCheck && nomeUsuarioError && !getLoadingNomeUsuario" class="text-danger">
                  <i class="fas fa-times-circle text-danger mr-1"></i>
                  O nome de usuário contém caracteres especiais que não são permitidos. Use apenas letras e números e os seguintes caracteres: "-",
                  "." e "_".
                </p>
                <p
                  v-if="nomeUsuario !== nomeUsuarioCheck && !getNomeUsuarioExists && !nomeUsuarioError && !getLoadingNomeUsuario"
                  class="text-success"
                >
                  <i class="fa fa-check-circle text-success mr-1"></i>
                  O nome de usuário está disponível.
                </p>
              </div>
            </div>

            <div class="row">
              <div class="pl-3 mb-1">Numero Documento</div>
              <div class="form-group col-12">
                <label for="cpf"><i class="fas fa-id-card"></i></label>
                <input
                  v-if="getUsuarioInfo?.tipoPessoa == 'PF'"
                  type="text"
                  id="cpf"
                  placeholder="CPF"
                  v-model="numeroDocumento"
                  v-mask="'###.###.###-##'"
                  required
                  disabled
                  class="disabled"
                />
                <input
                  v-if="getUsuarioInfo?.tipoPessoa == 'PJ'"
                  type="text"
                  id="cnpj"
                  placeholder="CNPJ"
                  v-model="numeroDocumento"
                  v-mask="'##.###.###/####-##'"
                  required
                  disabled
                  class="disabled"
                />
              </div>
            </div>
            <div class="row">
              <div class="pl-3" v-bind:class="getUsuarioInfo?.tipoPessoa != 'PJ' ? 'col-md-4' : 'col-md-6'">
                <div class="mb-1" v-if="getUsuarioInfo?.tipoPessoa == 'PJ'">Telefone 1</div>
                <div class="mb-1" v-if="getUsuarioInfo?.tipoPessoa == 'PF'">Celular</div>
              </div>
              <div class="pl-3" v-bind:class="getUsuarioInfo?.tipoPessoa != 'PJ' ? 'col-md-4' : 'col-md-6'" v-if="getUsuarioInfo?.tipoPessoa == 'PJ'">
                <div class="mb-1">Telefone 2</div>
              </div>
              <div class="pl-3 col-md-4" v-if="getUsuarioInfo?.tipoPessoa != 'PJ'">
                <div class="mb-1">RG</div>
              </div>
              <div class="pl-3 col-md-4" v-if="getUsuarioInfo?.tipoPessoa != 'PJ'">
                <div class="mb-1">Orgão Emissor</div>
              </div>
            </div>
            <div class="row">
              <div class="form-group" v-bind:class="getUsuarioInfo?.tipoPessoa != 'PJ' ? 'col-md-4' : 'col-md-6'">
                <label for="telefone"><i class="fas fa-phone-alt"></i></label>
                <input
                  type="text"
                  id="telefone"
                  placeholder="Telefone"
                  v-model="telefoneCelular"
                  v-mask="'(##) #####-####'"
                  required
                  v-if="getUsuarioInfo?.tipoPessoa == 'PJ'"
                />
                <input
                  type="text"
                  id="telefone"
                  placeholder="Celular"
                  v-model="telefoneCelular"
                  v-mask="'(##) #####-####'"
                  required
                  v-if="getUsuarioInfo?.tipoPessoa == 'PF'"
                />
              </div>
              <div class="form-group col-md-6" v-if="getUsuarioInfo?.tipoPessoa == 'PJ'">
                <label for="telefone2"><i class="fas fa-phone-alt"></i></label>
                <input type="text" id="telefone2" placeholder="Telefone" v-model="telefone" v-mask="'(##) #####-####'" required />
              </div>
              <div class="form-group col-md-4" v-if="getUsuarioInfo?.tipoPessoa != 'PJ'">
                <label for="rg"><i class="fas fa-id-card"></i></label>
                <input type="text" id="rg" placeholder="RG" v-model="rg" required />
              </div>
              <div class="form-group col-md-4" v-if="getUsuarioInfo?.tipoPessoa != 'PJ'">
                <label for="orgao-emissor"><i class="fas fa-users-cog"></i></label>
                <input type="text" id="orgao-emissor" placeholder="Orgão Emissor" v-model="orgaoEmissor" required />
              </div>
            </div>

            <div v-if="getUsuarioInfo?.responsavel && getUsuarioInfo.tipoPessoa == 'PJ'" class="mt-20">
              <div class="header">
                <h4 class="title">Informações do Responsável</h4>
                <!-- <span class="edit"><i class="flaticon-edit"></i> Editar</span> -->
              </div>

              <div class="row">
                <div class="pl-3 mb-1">Nome Completo</div>
                <div class="form-group col-md-12">
                  <label for="nome-completo"><i class="fas fa-user"></i></label>
                  <input type="text" id="nome-completo" placeholder="Nome completo" v-model="responsavel.nomeCompleto" required />
                </div>
              </div>

              <div class="row">
                <div class="pl-3 mb-1">CPF</div>
                <div class="form-group col-12">
                  <label for="cpf"><i class="fas fa-id-card"></i></label>
                  <input type="text" id="cpf" placeholder="CPF" v-model="responsavel.numeroDocumento" v-mask="'###.###.###-##'" required />
                </div>
              </div>
              <div class="row">
                <div class="pl-3 col-md-6">
                  <div class="mb-1">Data de Nascimento</div>
                </div>
                <div class="pl-3 col-md-6">
                  <div class="mb-1">Gênero</div>
                </div>
              </div>
              <div class="row">
                <div class="form-group col-md-6">
                  <label for="data-nascimento"><i class="fas fa-calendar-alt"></i></label>
                  <input
                    type="text"
                    id="data-nascimento"
                    placeholder="Data nascimento"
                    v-model="responsavel.dataNascimento"
                    v-mask="'##/##/####'"
                    required
                  />
                </div>
                <div class="form-group col-md-6">
                  <label for="genero"><i class="fas fa-venus-mars"></i></label>
                  <select id="genero" v-model="responsavel.genero" required>
                    <option value="">Selecione</option>
                    <option value="F">Feminino</option>
                    <option value="M">Masculino</option>
                    <option value="O">Outro</option>
                  </select>
                </div>
              </div>

              <div class="row">
                <div class="pl-3 mb-1">Celular</div>
                <div class="form-group col-md-12">
                  <label for="telefone"><i class="fas fa-mobile"></i></label>
                  <input type="text" id="telefone" placeholder="Telefone" v-model="responsavel.telefoneCelular" v-mask="'(##) #####-####'" />
                </div>
              </div>
            </div>

            <div class="header mt-20">
              <h4 class="title" v-if="getUsuarioInfo?.tipoPessoa == 'PF'">Endereço</h4>
              <h4 class="title" v-if="getUsuarioInfo?.tipoPessoa == 'PJ'">Endereço da Empresa</h4>
            </div>

            <div class="row">
              <div class="pl-3 col-md-4">
                <div class="mb-1">CEP</div>
              </div>

              <div class="pl-3 col-md-8">
                <div class="mb-1">Logradouro</div>
              </div>
            </div>

            <div class="row">
              <div class="form-group col-md-4">
                <label for="form-cep"><i class="fas fa-location-arrow"></i></label>
                <input type="text" id="form-cep" placeholder="cep" v-model="endereco.cep" required v-mask="'#####-###'" v-on:change="searchCep" />
                <span class="pass-type" v-if="getLoadingCep"><i class="fa fa-spin fa-spinner"></i></span>
              </div>

              <div class="form-group col-12 col-md-8">
                <label for="form-logradouro"><i class="fas fa-road"></i></label>
                <input type="text" id="form-logradouro" placeholder="Logradouro" v-model="endereco.logradouro" required />
              </div>
            </div>
            <div class="row">
              <div class="pl-3 col-md-4">
                <div class="mb-1">Numero</div>
              </div>

              <div class="pl-3 col-md-8">
                <div class="mb-1">Complemento</div>
              </div>
            </div>
            <div class="row">
              <div class="form-group col-md-4">
                <label for="form-numero"><i class="fas fa-map-pin"></i></label>
                <input type="text" id="form-numero" placeholder="Número" v-model="endereco.numero" required />
              </div>
              <div class="form-group col-12 col-md-8">
                <label for="form-complemento"><i class="fas fa-map-signs"></i></label>
                <input type="text" id="form-complemento" placeholder="Complemento" v-model="endereco.complemento" />
              </div>
            </div>
            <div class="row">
              <div class="pl-3 col-md-4">
                <div class="mb-1">Bairro</div>
              </div>

              <div class="pl-3 col-md-3">
                <div class="mb-1">Estado</div>
              </div>
              <div class="pl-3 col-md-5">
                <div class="mb-1">Cidade</div>
              </div>
            </div>
            <div class="row">
              <div class="form-group col-md-4">
                <label for="form-bairro"><i class="fas fa-building"></i></label>
                <input type="text" id="form-bairro" placeholder="Bairro" v-model="endereco.bairro" required />
              </div>
              <div class="form-group col-12 col-md-3">
                <label for="form-estado"><i class="fas fa-flag"></i></label>
                <select id="form-estado" v-model="endereco.estado" @change="searchMunicipios" required>
                  <option value="">Estado</option>
                  <option value="AC">AC</option>
                  <option value="AL">AL</option>
                  <option value="AP">AP</option>
                  <option value="AM">AM</option>
                  <option value="BA">BA</option>
                  <option value="CE">CE</option>
                  <option value="DF">DF</option>
                  <option value="ES">ES</option>
                  <option value="GO">GO</option>
                  <option value="MA">MA</option>
                  <option value="MT">MT</option>
                  <option value="MS">MS</option>
                  <option value="MG">MG</option>
                  <option value="PR">PR</option>
                  <option value="PB">PB</option>
                  <option value="PA">PA</option>
                  <option value="PE">PE</option>
                  <option value="PI">PI</option>
                  <option value="RJ">RJ</option>
                  <option value="RN">RN</option>
                  <option value="RS">RS</option>
                  <option value="RO">RO</option>
                  <option value="RR">RR</option>
                  <option value="SC">SC</option>
                  <option value="SE">SE</option>
                  <option value="SP">SP</option>
                  <option value="TO">TO</option>
                </select>
              </div>

              <div class="form-group col-md-5">
                <label for="form-cidade"><i class="fas fa-city"></i></label>
                <select name="cidade" id="form-cidade" v-model="endereco.cidade" required>
                  <option value="">Cidade</option>
                  <option v-if="getLoadingMunicipios" value="-1" selected>Carregando...</option>
                  <option v-for="c in getMunicipiosInfo" :key="c.id" :value="c.nome">{{ c.nome }}</option>
                </select>
              </div>
            </div>
            <div class="form-group mt-50 mb-30">
              <button type="submit" class="custom-button" :disabled="getNomeUsuarioExists && nomeUsuario !== nomeUsuarioCheck">
                <i class="fa fa-spin fa-spinner" v-if="loading == true" />
                Salvar
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import http from '@/service/http/http';
// import estados from '../../../config/config';
import moment from 'moment';
import Notification from '@/mixins/notification';
moment.locale('pt-br');
export default {
  name: 'edit-perfil',
  data() {
    return {
      usuarioId: '',
      identityId: '',
      nomeCompleto: '',
      nomeUsuarioCheck: '',
      nomeUsuario: '',
      nomeUsuarioError: null,
      dataNascimento: '',
      telefone: '',
      telefoneCelular: '',
      orgaoEmissor: '',
      rg: '',
      numeroDocumento: '',
      genero: '',
      responsavel: {
        nomeCompleto: '',
        dataNascimento: '',
        tipoPessoa: '',
        genero: '',
        numeroDocumento: '',
        telefoneCelular: '',
      },
      // estados: estados,
      debounce: null,
      endereco: {
        cep: '',
        logradouro: '',
        numero: '',
        complemento: '',
        bairro: '',
        cidade: '',
        estado: '',
      },
      tipoPessoa: '',
      error: '',
      loading: false,
    };
  },
  mixins: [Notification],
  computed: {
    ...mapGetters([
      'getUsuarioInfo',
      'getLoadingCep',
      'getAuth',
      'getLoadingMunicipios',
      'getMunicipiosInfo',
      'getLoadingNomeUsuario',
      'getNomeUsuarioExists',
    ]),
    getRg() {
      return this.getUsuarioInfo?.documentos?.find((e) => e.tipo == 'RG');
    },
    getCpf() {
      return this.getUsuarioInfo?.documentos?.find((e) => e.tipo == 'CPF');
    },
    getCnpj() {
      return this.getUsuarioInfo?.documentos?.find((e) => e.tipo == 'CNPJ');
    },
    verifyNomeUsuario() {
      return this.nomeUsuario !== this.nomeUsuarioCheck && (this.getNomeUsuarioExists || this.nomeUsuarioError) && !this.getLoadingNomeUsuario
        ? 'border border-danger'
        : this.nomeUsuario !== this.nomeUsuarioCheck && (!this.getNomeUsuarioExists || !this.nomeUsuarioError) && !this.getLoadingNomeUsuario
        ? 'border border-success'
        : '';
    },
  },
  methods: {
    ...mapActions(['setCadastro', 'loadCep', 'info', 'loadMunicipios', 'checkNomeUsuario']),
    async cadastro() {
      this.loading = true;

      let payload = {};
      if (this.getUsuarioInfo?.tipoPessoa === 'PF') {
        payload = {
          usuarioId: this.usuarioId,
          identityId: this.identityId,
          nomeCompleto: this.nomeCompleto,
          email: this.email,
          nomeUsuario: this.nomeUsuario,
          dataNascimento: moment(this.dataNascimento, 'DD/MM/YYYY').toISOString(),
          orgaoEmissor: this.orgaoEmissor,
          telefoneCelular: this.telefoneCelular,
          telefoneConvencional: this.telefone,
          rg: this.rg,
          genero: this.genero,
          numeroDocumento: this.numeroDocumento,
          tipoPessoa: this.getUsuarioInfo?.tipoPessoa,
          endereco: {
            cep: this.endereco.cep,
            logradouro: this.endereco.logradouro,
            numero: this.endereco.numero,
            complemento: this.endereco.complemento,
            bairro: this.endereco.bairro,
            cidade: this.endereco.cidade,
            estado: this.endereco.estado,
          },
          perfis: [1],
          emailConfirmado: true,
          ativo: true,
        };
      } else {
        payload = {
          usuarioId: this.usuarioId,
          identityId: this.identityId,
          nomeCompleto: this.nomeCompleto,
          email: this.email,
          nomeUsuario: this.nomeUsuario,
          telefoneCelular: this.telefoneCelular,
          telefoneConvencional: this.telefone,
          numeroDocumento: this.numeroDocumento,
          tipoPessoa: this.getUsuarioInfo?.tipoPessoa,
          responsavel: {
            ...this.responsavel,
            dataNascimento: moment(this.responsavel.dataNascimento, 'DD/MM/YYYY').toISOString(),
          },
          endereco: {
            cep: this.endereco.cep,
            logradouro: this.endereco.logradouro,
            numero: this.endereco.numero,
            complemento: this.endereco.complemento,
            bairro: this.endereco.bairro,
            cidade: this.endereco.cidade,
            estado: this.endereco.estado,
          },
          perfis: [1],
          emailConfirmado: true,
          ativo: true,
        };
      }
      try {
        await http.put(`usuario/${this.identityId}/atualizar`, payload);
        this.loading = false;
        this.showToast({ title: 'Perfil atualizado com sucesso' });
        this.$router.push({ name: 'perfil' });
      } catch (_) {
        this.loading = false;
        this.showAlert({
          type: 'error',
          title: 'ATENÇÃO',
          message: 'Erro ao atualizar o perfil',
        });
      }

      this.loading = false;
    },

    async searchCep(event) {
      if (event) {
        event.preventDefault();
      }

      if (this.endereco.cep.length === 9) {
        this.loadCep(this.endereco.cep)
          .then(async (resp) => {
            this.endereco.logradouro = resp.logradouro;
            this.endereco.bairro = resp.bairro;
            this.endereco.estado = resp.uf;
            await this.searchMunicipios();
            this.endereco.cidade = resp.localidade;
          })
          .catch(() => {
            this.endereco.logradouro = '';
            this.endereco.bairro = '';
            this.endereco.cidade = '';
            this.endereco.estado = '';
          });
      }
    },

    async searchMunicipios() {
      this.endereco.cidade = '-1';
      await this.loadMunicipios(this.endereco.estado);
      this.endereco.cidade = '';
    },

    debounceCheckNomeUsuario() {
      if (this.debounce) {
        clearTimeout(this.debounce);
      }
      this.debounce = setTimeout(this.checkNomeUsuarioExists, 300);
    },

    async checkNomeUsuarioExists() {
      if (this.nomeUsuario === '' || this.nomeUsuario === null || this.nomeUsuario === undefined) {
        this.error = 'Nome de Usuário é obrigatório';
        return false;
      }
      if (this.nomeUsuario.length > 15) {
        this.error = 'Nome de Usuário não pode ter mais de 15 caracteres';
        return false;
      }

      await this.checkNomeUsuario(this.nomeUsuario);

      const regex = /[!@#$%^&*()+{}\\[\]:;<>,?~´`çÇ\s]/gm;

      this.nomeUsuarioError = regex.test(this.nomeUsuario);
    },

    switchVisibility() {
      this.passwordFieldType = this.passwordFieldType === 'password' ? 'text' : 'password';
    },
    switchVisibility2() {
      this.passwordFieldType2 = this.passwordFieldType2 === 'password' ? 'text' : 'password';
    },
    getUsuario(usuarioId) {
      return http({
        url: `usuario/${usuarioId}`,
        method: 'get',
      });
    },
  },

  async created() {
    await this.info();
    this.usuarioId = this.getUsuarioInfo?.usuarioId;
    this.identityId = this.getAuth.uid;
    this.nomeCompleto = this.getUsuarioInfo?.nomeCompleto;
    this.nomeUsuarioCheck = this.getUsuarioInfo?.nomeUsuario;
    this.nomeUsuario = this.getUsuarioInfo?.nomeUsuario;
    this.dataNascimento = moment(this.getUsuarioInfo?.dataNascimento, 'YYYY-MM-DD').format('DD/MM/YYYY');
    this.dataEmissor = moment(this.getRg?.dataEmissao, 'YYYY-MM-DD').format('DD/MM/YYYY');
    this.orgaoEmissor = this.getRg?.orgaoEmissor;
    this.rg = this.getRg?.numeroDocumento;
    this.tipoPessoa = this.getUsuarioInfo?.tipoPessoa;
    this.numeroDocumento = this.getCpf?.numeroDocumento || this.getCnpj?.numeroDocumento;
    this.email = this.getAuth?.email;
    this.genero = this.getUsuarioInfo?.genero;
    this.telefoneCelular = this.getUsuarioInfo?.telefone;
    this.telefone = this.getUsuarioInfo?.telefoneConvencional;
    if (this.getUsuarioInfo?.endereco) {
      this.endereco.cep = this.getUsuarioInfo?.endereco.cep;
      this.endereco.logradouro = this.getUsuarioInfo?.endereco.logradouro;
      this.endereco.numero = this.getUsuarioInfo?.endereco.numero;
      this.endereco.complemento = this.getUsuarioInfo?.endereco.complemento;
      this.endereco.bairro = this.getUsuarioInfo?.endereco.bairro;
      this.endereco.estado = this.getUsuarioInfo?.endereco.estado;
      await this.searchMunicipios();
      this.endereco.cidade = this.getUsuarioInfo?.endereco.cidade;
    }
    if (this.getUsuarioInfo?.responsavel) {
      this.responsavel = {
        nomeCompleto: this.getUsuarioInfo?.responsavel.nomeCompleto,
        dataNascimento: moment(this.getUsuarioInfo?.responsavel.dataNascimento, 'YYYY-MM-DD').format('DD/MM/YYYY'),
        tipoPessoa: this.getUsuarioInfo?.responsavel.tipoPessoa,
        genero: this.getUsuarioInfo?.responsavel.genero,
        numeroDocumento: this.getUsuarioInfo?.responsavel.numeroDocumento,
        telefoneCelular: this.getUsuarioInfo?.responsavel.telefoneCelular,
      };
    }
  },

  filters: {
    formatData(data) {
      if (data) return data.substring(0, 10).split('-').reverse().join('/');
    },
    formatTelefone(tel) {
      if (!tel || tel.length < 11) return '';

      if (typeof tel !== 'string') tel = tel.toString();

      tel = tel.replace(/\D/g, '');

      return tel.replace(/(\d{2})(\d{5})(\d{4})/, '($1)$2-$3');
    },
  },
};
</script>

<style scoped>
.login-form .form-group input,
select {
  padding-left: 40px;
}
</style>
